/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import HintBox from "../../../Box/HintBox/HintBox";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import SettlementCosts from "../../../Serviceworld/Settlement/SettlementCosts";
import PowerOfAttorneyNextSteps from "../../Common/PowerOfAttorney/PowerOfAttorneyNextSteps";

type PowerOfAttorneyHintBoxProps = {
  product: AbstractCase;
};

export default function PowerOfAttorneyHintBox({ product }: PowerOfAttorneyHintBoxProps) {
  return (
    <HintBox headline={"So geht es weiter"}>
      <PowerOfAttorneyNextSteps bulletPoints={[
        "Wir melden uns umgehend bei Ihnen und Sie können sich flexibel einen Termin für ein anwaltliches Erstgespräch vereinbaren",
        "Damit wir Ihre Kündigung kostenlos prüfen können, benötigen wir Ihre Vollmacht",
        "Wenn alle Fragen geklärt sind und Ihre Möglichkeiten und Wünsche besprochen wurden, wird die Kündigungsschutzklage finalisiert und bei Gericht eingereicht",
        "Über den gesamten Prozess werden Sie persönlich von unserem Expertenteam begleitet und wir sind bei Fragen selbstverständlich immer für Sie erreichbar",
      ]} />
      <SettlementCosts settlement={product} />
    </HintBox>
  );
}
